export const environment = {
  production: false,

  clientName: 'presto',
  apiGatewayFront: 'https://agp.presto.com.co/',
  apiGatewayBackOffice: 'https://agp.presto.com.co/',
  apiUrl: 'https://agp.presto.com.co/',
  urlPath: 'https://agp.presto.com.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6Lc_PAkqAAAAADhHHrIU_oBcjnrjRT0T4W5zqitp',

  googleAnalyticsCode: 'UA-140785247-1',
};